import React from 'react';

import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';

import type { DateFilter, FilterProps } from './types';

export default function CompCustomFieldDateFilter({ filter = {}, schema, onChange }: FilterProps<DateFilter>) {
  return (
    <FilterDatePickerPair
      filter={filter}
      label={schema.label}
      valueKeys={['min', 'max']}
      onChange={(value: string, key: string) => onChange({ ...filter, [key]: value })}
    />
  );
}
